// src/api/fetchNews.js
import axiosClient from './axiosClient';

/**
 * Fetches paginated news articles.
 * 
 * @param {object} options
 * @param {number} [options.pageParam=1]
 * @returns {Promise<{articles: object[], nextPage: number, totalResults: number}>}
 */
export async function fetchNews({ pageParam = 1 }) {
  const pageSize = 10;
  const response = await axiosClient.get(`/news?page=${pageParam}&page_size=${pageSize}`);
  return {
    articles: response.data.articles,
    nextPage: pageParam + 1,
    totalResults: response.data.totalResults,
  };
}

/**
 * Fetches the latest news articles from the v2 endpoint.
 * Expects query parameters for filtering and pagination.
 */
export async function fetchNewsV2({
  country,
  language = "en",
  category,
  q,
  size = 5,
  next_page,
  allowed_domains,
}) {
  const params = { country, language, category, q, size, next_page };
  // If allowed_domains is provided, ensure it is a comma-separated string.
  if (allowed_domains) {
    params.allowed_domains = Array.isArray(allowed_domains)
      ? allowed_domains.join(",")
      : allowed_domains;
  }
  const response = await axiosClient.get('/news/v2', { params });
  return response.data;
}

/**
 * Fetches detailed article information (full text) from the v2/detail endpoint.
 * @param {string} url The source URL of the article.
 */
export async function fetchNewsArticleDetail(url) {
  const response = await axiosClient.get('/news/v2/detail', { params: { url } });
  return response.data;
}
